import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GET, POST } from '../../Services/AxiosService';
import { CustomStringify } from "../../Helpers/CustomStringify";

export const fetchDataPK = createAsyncThunk(
    'PackingChallanData/fetchDataPK',
    async ({
        cmpdetail,
        UserDetail,
        page = 1,
        limit = 30,
        search = "",
        fromDate = "",
        toDate = "",
    }, { rejectWithValue }) => {
        let query = new URLSearchParams();
        if (page) query.append("page", page);
        if (limit) query.append("limit", limit);
        if (search) query.append("search", search);
        if (fromDate) query.append("fromDate", fromDate);
        if (toDate) query.append("toDate", toDate);

        try {
            const result = await GET(`/purchase/${cmpdetail?.key}?supplier_name=${encodeURIComponent(UserDetail?.result?.user?.company_name)}&${query.toString()}`);
            console.log("PackingChallan Data", result)
            return result;
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message || error?.message)
        }
    }
);

export const fetchPOpendingList = createAsyncThunk(
    "PurchaseOrderPendingList/fetchPOpendingList",
    async ({ cmpdetail, UserDetail }, { rejectWithValue }) => {
        try {
            const result = await GET(`purchaseorders/download/${cmpdetail?.key}?listtype=pendingorders&party=${encodeURIComponent(UserDetail?.result?.user?.company_name)}`)
            return result
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message || error?.message)
        }
    }
)



const PackingChallanDataSlice = createSlice({
    name: 'PackingChallanData',
    initialState: {
        result: {},
        status: 'idle',
        error: null,

        //Po pendign list state 
        poresult: {},
        postatus: 'idle',
        poerror: null,

    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchDataPK.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchDataPK.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.result = action.payload;
            })
            .addCase(fetchDataPK.rejected, (state, action) => {
                state.status = 'failed';
                state.result = {};
                state.error = action.payload;
            })

            // PO Pending List Handle
            .addCase(fetchPOpendingList.pending, (state) => {
                state.postatus = 'loading';
            })
            .addCase(fetchPOpendingList.fulfilled, (state, action) => {
                state.postatus = 'succeeded';
                state.poresult = action.payload;
            })
            .addCase(fetchPOpendingList.rejected, (state, action) => {
                state.postatus = 'failed';
                state.poresult = {};
                state.poerror = action.payload;
            });

    },
});

export default PackingChallanDataSlice.reducer;